"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _common = _interopRequireDefault(require("cccisd-survey-common/dist/styles/common.css"));
var _Area = _interopRequireDefault(require("./Area"));
var _cccisdResponsive = _interopRequireDefault(require("cccisd-responsive"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _classnames2 = _interopRequireDefault(require("classnames"));
var _reactDndMultiBackend = require("react-dnd-multi-backend");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var minImageWidth = 600;

// Add div to the body where we will render the dragged element clone
var element = document.getElementById(_style["default"].clone);
if (!element) {
  element = document.createElement('div');
  element.setAttribute('id', _style["default"].clone);
  document.body.appendChild(element);
}
var getScale = function getScale(width) {
  return width / Math.max(width, minImageWidth);
};
var Preview = function Preview(props) {
  var _usePreview = (0, _reactDndMultiBackend.usePreview)(),
    display = _usePreview.display,
    previewStyle = _usePreview.style;
  var placeholder = props.placeholder,
    width = props.width,
    imageLayout = props.imageLayout;
  if (!display || !placeholder) {
    return null;
  }
  var transform = previewStyle.transform;
  if (imageLayout) {
    var scale = getScale(width);
    if (scale < 1) {
      transform += " scale(".concat(scale, ")");
    }
  }
  return /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      left: 0,
      top: 0,
      position: 'fixed',
      pointerEvents: 'none',
      width: "".concat(placeholder.width, "px"),
      height: "".concat(placeholder.height, "px"),
      transform: transform,
      transformOrigin: '0 0'
    },
    className: _style["default"].sourceItem + ' ' + _style["default"].grabbed
  }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: placeholder.html
  })), element);
};
var Image = function Image(props) {
  var sourceArea = props.sourceArea,
    feedbackArea = props.feedbackArea,
    imageLayout = props.imageLayout,
    width = props.width,
    feedback = props.feedback,
    sourceBlock = props.sourceBlock,
    targets = props.targets,
    targetItems = props.targetItems,
    useScaling = props.useScaling;
  var imageWidth = Math.max(width, minImageWidth);
  var scale = getScale(width);
  var imageHeight = 0;
  if (imageLayout) {
    imageHeight = imageLayout.metadata.height / imageLayout.metadata.width * imageWidth;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].imageHolder,
    style: {
      paddingTop: "".concat(imageLayout.metadata.height / imageLayout.metadata.width * 100, "%")
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].imageLayout,
    style: _objectSpread({
      backgroundImage: "url(".concat(imageLayout.url, ")")
    }, useScaling ? {
      width: "".concat(imageWidth, "px"),
      height: "".concat(imageHeight, "px"),
      transform: "scale(".concat(scale, ")")
    } : {
      width: '100%',
      height: '100%'
    })
  }, feedback && feedbackArea && /*#__PURE__*/_react["default"].createElement(_Area["default"], {
    left: feedbackArea.x,
    top: feedbackArea.y,
    width: feedbackArea.width,
    height: feedbackArea.height
  }, feedback), sourceArea && /*#__PURE__*/_react["default"].createElement(_Area["default"], {
    left: sourceArea.x,
    top: sourceArea.y,
    width: sourceArea.width,
    height: sourceArea.height
  }, sourceBlock), targets.map(function (target, index) {
    return target.area ? /*#__PURE__*/_react["default"].createElement(_Area["default"], {
      key: target.id,
      left: target.area.x,
      top: target.area.y,
      width: target.area.width,
      height: target.area.height
    }, targetItems[index]) : null;
  })));
};
var _default = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);
  function _default() {
    _classCallCheck(this, _default);
    return _callSuper(this, _default, arguments);
  }
  _createClass(_default, [{
    key: "render",
    value: function render() {
      var _playerTemplateProps$, _playerTemplateProps$2;
      var _this$props = this.props,
        settings = _this$props.settings,
        question = _this$props.question,
        sourceBlock = _this$props.sourceBlock,
        targetItems = _this$props.targetItems,
        elementStyle = _this$props.elementStyle,
        feedback = _this$props.feedback,
        placeholder = _this$props.placeholder,
        playerTemplateProps = _this$props.playerTemplateProps;
      var targets = settings.targets,
        targetTypes = settings.targetTypes,
        imageLayout = settings.imageLayout,
        sourceArea = settings.sourceArea,
        feedbackArea = settings.feedbackArea,
        showFeedback = settings.showFeedback,
        feedbackPosition = settings.feedbackPosition;
      var showFixedFeedback = showFeedback && feedbackPosition === 'fixed';
      var useScaling = !(playerTemplateProps !== null && playerTemplateProps !== void 0 && (_playerTemplateProps$ = playerTemplateProps.playerTemplateSettings) !== null && _playerTemplateProps$ !== void 0 && _playerTemplateProps$.showStickyBottomBar) || !(playerTemplateProps !== null && playerTemplateProps !== void 0 && (_playerTemplateProps$2 = playerTemplateProps.playerTemplateSettings) !== null && _playerTemplateProps$2 !== void 0 && _playerTemplateProps$2.scaleContent);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames2["default"])(_common["default"].lastRow, _common["default"].elementWrapper, _common["default"][elementStyle], _style["default"].fixIosBug)
      }, /*#__PURE__*/_react["default"].createElement(_cccisdResponsive["default"], {
        stylesheet: _style["default"],
        widthBreakpoints: {
          xsmall: 400,
          small: 600,
          medium: 800
        },
        render: function render(_ref) {
          var width = _ref.width;
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Preview, {
            imageLayout: imageLayout,
            width: width,
            placeholder: placeholder
          }), question && /*#__PURE__*/_react["default"].createElement("div", {
            className: _common["default"].margin
          }, question), imageLayout ? /*#__PURE__*/_react["default"].createElement(Image, {
            imageLayout: imageLayout,
            sourceArea: sourceArea,
            feedbackArea: feedbackArea,
            sourceBlock: sourceBlock,
            targets: targets,
            targetItems: targetItems,
            width: width,
            feedback: feedback,
            useScaling: useScaling
          }) : /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].contentWrapper
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: (0, _classnames2["default"])(_style["default"].content, _style["default"]["columns".concat(targets.length + 1)], _defineProperty({}, _style["default"].withFixedFeedback, showFixedFeedback))
          }, sourceBlock, showFixedFeedback && /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].feedbackArea
          }, feedback), targets.map(function (target, index) {
            var _targetTypes$static$f = targetTypes["static"].find(function (type) {
                return type.id === target.id;
              }),
              showTargetLabel = _targetTypes$static$f.showTargetLabel;
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: target.id,
              className: _style["default"].notebookWrapper
            }, showTargetLabel && /*#__PURE__*/_react["default"].createElement("div", {
              className: _style["default"].targetTitle
            }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
              content: target.label
            })), /*#__PURE__*/_react["default"].createElement("div", {
              className: _style["default"].notebook
            }, targetItems[index]));
          }))));
        }
      }));
    }
  }]);
  return _default;
}(_react["default"].Component);
_defineProperty(_default, "propTypes", {
  question: _propTypes["default"].node,
  sourceBlock: _propTypes["default"].node,
  feedback: _propTypes["default"].node,
  targetItems: _propTypes["default"].array,
  settings: _propTypes["default"].object,
  elementStyle: _propTypes["default"].string,
  placeholder: _propTypes["default"].object,
  playerTemplateProps: _propTypes["default"].object
});